export default {"src":"/_next/static/media/standardised-profiles.05d2e0f7.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};